import React from 'react';
import { ID, isNode, Node } from './GraphData'
import { useState, useLayoutEffect, useEffect, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom'
import './App.css';

import { GraphComponent } from './GraphComponent'
import { SearchPanel } from './SearchPanel'
import { Header } from './Header'
import { OverviewWindow } from './OverviewWindow';
import { ModalUsageProps } from './Modal'
import * as cmd from './userCommands'

import GraphData from './GraphData'
import { WorkspaceData } from './GraphData'
import modal from './Modal'
import * as cst from './cst'
import { isString } from 'util';
import { log } from 'console';


function App() {  

  const urlParams = useParams()

  const [graphData, setGraphData] = useState(new GraphData())
  const [network, setNetwork] = useState(null)
  const [selectedNodeObject, setSelectedNodeObject] = useState<Node>(null)
  const [modalUp, setModalUp] = useState<boolean>(false)

  const [sortedNodes, setSortedNodes] = useState<Node[]>([])
  const [filteredNodes, setFilteredNodes] = useState<Node[]>([])
  const [workspaces, setWorkspaces] = useState<WorkspaceData[]>([])

  const [newEdgeActive, setNewEdgeActive] = useState<boolean>(false)
  const [highlightedNodes, setHighlightedNodes] = useState<ID[]>([])

  const [filterOptions, setFilterOptions] = useState<Set<string>>()
  const [selectedFilterOption, setSelectedFilterOption] = useState<string>("")

  const newEdgeActiveRef = useRef<boolean>(false)
  const highlightedNodesRef = useRef<ID[]>([])
  const selectedNodeObjectRef = useRef<Node>(null);
  const filteredNodesRef = useRef<Node[]>([]);
  const modalUpRef = useRef<boolean>(false);
  const graphRef = useRef<HTMLElement | undefined>();

  let moving = false
  let shiftDown = false

  const fetchWorkspaces = async () => {
    const token = localStorage.getItem("TTAccessToken") 
    const url = localStorage.getItem("TTUrl")
    let data : any
    try {
      const response = await fetch(`${url}/api/workspaces?token=${token}`)
      data = await response.json()
      if(data){
        setWorkspaces(data.workspaceData)
      }
    } catch (error) {
      console.error(error)
    }
    return data
  }

  useEffect(() => {

    setSortedNodes(graphData.getNodesByPriority())
    window.addEventListener("blur", clearHeldKeys);
    window.addEventListener("focus", clearHeldKeys);

    fetchWorkspaces()
    updateUrlParams()

    return () => {
      window.removeEventListener("blur", clearHeldKeys);
      window.removeEventListener("focus", clearHeldKeys);
    }

  }, []);

  const updateUrlParams = async () => {

    const {workspaceParam, nodeParam} = urlParams //TODO node param zoom
    if(workspaceParam && workspaceParam != graphData.getWorkspace()){

      localStorage.setItem("TTCurrentWorkspace", workspaceParam)
      graphData.setWorkspace(workspaceParam)

      if(network){
        await graphData.fetchGraph();
        await reloadGraph()
      }
    }
    if(nodeParam){
      const parsedId = parseInt(nodeParam)
      if(parsedId && graphData.getNodes().find(n => parsedId === n.id)){
        console.log("found")
        moveToNode(parsedId)
        network.selectNodes([parsedId])
      }
    }
  }

  useEffect(() => {

    updateUrlParams()

  }, [urlParams])

  useEffect(() => {

    const fetchData = async () => {
      if (network) {
        try {
          await graphData.fetchGraph();
          await reloadGraph()
          document.addEventListener('keydown', handleKeyDown);
          document.addEventListener('keyup', handleKeyUp);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
        updateUrlParams()
      }
    }

    fetchData()

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    }
  }, [network])


  useEffect(() => {
    modalUpRef.current = modalUp;
  }, [modalUp])

  useEffect(() => {
    newEdgeActiveRef.current = newEdgeActive;
  }, [newEdgeActive])

  useEffect(() => {
    highlightedNodesRef.current = highlightedNodes;
    network && reloadGraph()
  }, [highlightedNodes])

  useEffect(() => {
    selectedNodeObjectRef.current = selectedNodeObject;
  }, [selectedNodeObject])

  useEffect(() => {
    if(selectedFilterOption)
      reloadGraph()
  }, [selectedFilterOption])

  useEffect(() => {
    filteredNodesRef.current = filteredNodes;
  }, [filteredNodes])
  

  const reloadGraph = async ()  => {
    const view = { position: network.getViewPosition(), scale: network.getScale() }
    let selection = network.getSelection()
    let selectedNode : ID
    if(selection.nodes.length == 1){
        selectedNode = selection.nodes[0]
    }
    selectedFilterOption && graphData.setSelectedFilterOption(selectedFilterOption)
    highlightedNodes && graphData.setHighlightedNodes(highlightedNodesRef.current)
    await graphData.performLayout()
    await network.setData(graphData.getGraph())
    network.moveTo(view)
    if(graphData.getNode(selectedNode)){
      network.selectNodes([selectedNode])
    }
    setSortedNodes(graphData.getNodesByPriority())
    graphData.registerNodes()
    setFilterOptions(graphData.getNames())
  }

  const moveToNode = (node : ID, zoom : boolean = false) : void => {
    const focusedElement = document.activeElement as HTMLElement
    if (focusedElement) {
      focusedElement.blur()
    }
    if(moving){
      return
    }
    moving = true
    // console.log(moving)
    if(zoom){
      network.focus(node, {scale:1.5, animation:{duration:150, easingFunction:"easeInOutCubic"}}) //Weird bug in vis. Not checking for "Moving" can kill the view.
    }
    else{
      network.focus(node, {animation:{duration:150, easingFunction:"easeInOutCubic"}}) //Weird bug in vis. Not checking for "Moving" can kill the view.
    }
    setTimeout(()=>{moving = false; network.focus(node)}, 150)
  }

  //
  //Event listeners
  //
  //

  const clearHeldKeys = () => {
    shiftDown = false
  }
  const clearEverything = () => {
    setHighlightedNodes([])
    setNewEdgeActive(false)
    network.selectNodes([])
    clearHeldKeys()
    reloadGraph()
  }
  const preMod = async () => {
    await graphData.fetchGraph();
    await reloadGraph()
  }
  const postMod = async () => {
    await reloadGraph()
    await graphData.saveGraph();
  }

  const keybinds = {
    "?" : {action: cmd.helpModal, params: [setModalUp]},
    "ArrowLeft" :   {
      action: cmd.handleArrowNavigation, 
      params: ["ArrowLeft","$selectedNode",graphData,network], 
      moveToResult : true, mustNotBeMoving : true},
    "ArrowRight" :   {
      action: cmd.handleArrowNavigation, 
      params: ["ArrowRight","$selectedNode",graphData,network], 
      moveToResult : true, mustNotBeMoving : true},
    "ArrowUp" :   {
      action: cmd.handleArrowNavigation, 
      params: ["ArrowUp","$selectedNode",graphData,network], 
      moveToResult : true, mustNotBeMoving : true},
    "ArrowDown" :   {
      action: cmd.handleArrowNavigation, 
      params: ["ArrowDown","$selectedNode",graphData,network], 
      moveToResult : true, mustNotBeMoving : true},
    "Home" : {
      action: cmd.jumpToStart, 
      params: [graphData, network],
      moveToResult: true, mustNotBeMoving : true},
    "End" : {
      action: cmd.jumpToEnd, 
      params: [graphData, network],
      moveToResult: true, mustNotBeMoving : true},
    "Shift+ArrowLeft" :   {
      action: cmd.swapToLeft, 
      params: ["$selectedNode",graphData],
      modifies: true, moveToResult: true, mustNotBeMoving : true},
    "Shift+ArrowRight" :   {
      action: cmd.swapToRight, 
      params: ["$selectedNode",graphData],
      modifies: true, moveToResult: true, mustNotBeMoving : true},
    "Shift+Home" :   {
      action: cmd.swapToStart, 
      params: ["$selectedNode",graphData],
      modifies: true, moveToResult: true, mustNotBeMoving : true},
    "Shift+End" :   {
      action: cmd.swapToEnd, 
      params: ["$selectedNode",graphData],
      modifies: true, moveToResult: true, mustNotBeMoving : true},
    " " :   {
      action: (selectedNode : ID) => graphData.cycleStateUp(selectedNode), 
      params: ["$selectedNode"],
      modifies: true},
    "Shift+ " :   {
      action: (selectedNode : ID) => graphData.cycleStateDown(selectedNode), 
      params: ["$selectedNode"],
      modifies: true},
    "c" :   {
      action: cmd.toggleCollapsed,
      params: ["$selectedNode",graphData],
      modifies: true},
    "Escape" :   {
      action: clearEverything,
      params: []},
    "s" :   {
      action: cmd.selectSubTree, 
      params: ["$selectedNode",graphData,network]},
    "#" :   {
      action: cmd.jumpByNumber, 
      params: ["$key", filteredNodesRef, graphData, network, reloadGraph],
      moveToResult: true, mustNotBeMoving : true},
    "d" :   {
      action: cmd.deleteSelection, 
      params: [graphData, network, setModalUp, clearHeldKeys, preMod, postMod],
      modifies: false /*included inside*/, moveToResult: true},
    "a" :   {
      action: cmd.newEdgeActivate, 
      params: [network, newEdgeActiveRef, setNewEdgeActive, setHighlightedNodes, reloadGraph]},
    "Delete" :   {
      action: cmd.deleteSelection, 
      params: [graphData, network, setModalUp, clearHeldKeys, preMod, postMod],
      modifies: false /*included inside*/, moveToResult: true},
    "n" :   {
      action: cmd.newNode, 
      params: [graphData, network, setModalUp, clearHeldKeys, preMod, postMod],
      modifies: false, moveToResult: true},
    "e" :   {
      action: cmd.editNode, 
      params: [graphData, network, setModalUp, clearHeldKeys, preMod, postMod]},
    "Enter" :   {
      action: cmd.editNode, 
      params: [graphData, network, setModalUp, clearHeldKeys, preMod, postMod]},
    "PageUp" :   {
      action: () => network.moveTo({scale:network.getScale()*1.375}), 
      params: []},
    "PageDown" :   {
      action: () => network.moveTo({scale:network.getScale()/1.375}), 
      params: []},
  }

  const handleKeyDown = async (event : any) => {
    if(modalUpRef.current){ //Do not allow regular keyboard input if a modal is up
      return
    }
    const { key } = event;
    if( key === "Shift"){
      shiftDown = true
    }
    const whitelistedKeys = ["Shift","?","Enter","Escape",
                             "1","2","3","4","5",
                             "6","7","8","9","0"]
    let moddedKey = key
    if(shiftDown && !(whitelistedKeys.includes(key))){
      moddedKey = "Shift+" + moddedKey
    }
    if (key.charCodeAt(0) >= 49 && key.charCodeAt(0) <= 57){ //1-9
      moddedKey = "#"
    }
    if(!keybinds.hasOwnProperty(moddedKey)){
      return
    }
    const action : Function = keybinds[moddedKey].action
    const params : Array<any> = [...keybinds[moddedKey].params]
    const modifies = keybinds[moddedKey].modifies
    const moveToResult = keybinds[moddedKey].moveToResult
    const mustNotBeMoving = keybinds[moddedKey].mustNotBeMoving

    if(moving && mustNotBeMoving){
      return
    }
    //Assign local variables
    params.forEach(param => {
      if(typeof param === "string" && param[0] === "$"){
        const idx = params.indexOf(param)
        let newval : any
        switch (param) {
          case "$moving":
            newval = moving
            break
          case "$selectedNode":
            const selection = network.getSelection()
            let selectedNode : ID
            if(selection.nodes.length == 1){
                selectedNode = selection.nodes[0]
            }
            newval = selectedNode
            break
          case "$key":
            newval = key
            break
          default:
            console.error("Incorrect keyboard control parameter: " + param)
        }
        params[idx] = newval
      }
    })
    //Check if node selected if required
    let idx : number
    idx = keybinds[moddedKey].params.indexOf("$selectedNode")
    if(idx != -1 && !params[idx]){
      return
    }
    if(modifies){ //In more complex cases, preMod and postMod are passed into the called function
      await preMod()
    }
    const result : ID = await action(...params)
    if(modifies){ 
      await postMod()
    }
    if(moveToResult && result){
      moveToNode(result)
    }
    return
  }

  const handleKeyUp = async (event) => {
    const { key } = event;

    if (key === "Shift"){
      shiftDown = false
    }
  }

  const handleClick = async (event) => {
    if(newEdgeActiveRef.current && event.nodes.length){
      await preMod()
      cmd.createNewEdge(graphData, highlightedNodes, event.nodes[0], setNewEdgeActive, setHighlightedNodes, reloadGraph)
      await postMod()
    }
  }

  const selectNodeFromPanel = (id : ID) => {
    network.selectNodes([id])
    if(network.getScale() < 1.5){
      moveToNode(id,true)
    }
    else{
      moveToNode(id)
    }
    if(graphData.uncollapseParentTree(id)){
      reloadGraph()
    }
  }

  const updateSelected = () => {
    let selection = network.getSelection()
    if(selection.nodes.length == 1){
        setSelectedNodeObject(graphData.getNode(selection.nodes[0]))
    }
    else{
      setSelectedNodeObject(null)
    }
  }


  const tokenModal = async () => {
    clearHeldKeys()
    setModalUp(true)
    try {
      const val : any = await modal(
        cst.MODAL_FORM,
        "Editing Connection",
        {
          "token":{type:"string", value:localStorage.getItem("TTAccessToken")},
          "url":{type:"string", value:localStorage.getItem("TTUrl")},
        }
      )
      
      if(!(
        val != undefined && typeof val === 'object' && 
        val.token && typeof val.token ==='string' &&
        val.url && typeof val.url ==='string'))
      {
        throw "exit"
      }
      const token : string = val.token
      const url : string = val.url.replace(/\/$/, "") //Strip trailing slash
      const validation : any = (await fetch(`${url}/api/validate?token=${token}`))
      if(!validation){
        throw "Failed to validate token. URL likely incorrect."
      }
      const data = await validation.json()
      if(data.valid === "read" || data.valid === "readWrite"){
        await modal(
          cst.MODAL_INFO,
          "Success",
          {"Token permissions":{value:data.valid}}
        )
        localStorage.setItem("TTAccessToken", token)
        localStorage.setItem("TTUrl", url)
        await graphData.fetchGraph();
        await reloadGraph()
      }
      else{
        throw "Invalid token.";
      }
    }
    catch(e){
      if(e==="exit"){
        return
      }
      await modal(
        cst.MODAL_INFO,
        "Failure",
        {"Error":{value:e.toString()}}
      )
    }
    finally{
      setModalUp(false)
    }
  }



  const importModal = () => {
    clearHeldKeys()
    setModalUp(true)
    modal(
      cst.MODAL_FORM,
      "Importing Graph Data",
      {"data":{type:"textarea"}}
    ).then(async val=>{
      if(val != undefined && typeof val === 'object' && val.data && typeof val.data ==='string'){
        await graphData.importGraph(val.data)
        graphData.saveGraph()
        reloadGraph()
      }
    })
    .catch(e=>{console.log(e)})
    .finally(()=>setModalUp(false))
  }

  const exportModal = () => {
    const data = graphData.exportGraph()
    clearHeldKeys()
    setModalUp(true)
    modal(
      cst.MODAL_INFO,
      "Exported Graph Data",
      {"data":{value:data, type:"textarea"}}
    )
    .finally(()=>setModalUp(false))
  }

  const modalUsageProps : ModalUsageProps = {
    clearHeldKeys : clearHeldKeys,
    setModalUp : setModalUp,
    graphData : graphData,
    reloadGraph : reloadGraph 
  }

  return (
    <div className="app" >
      <Header
        modalUsageProps={modalUsageProps}
        workspaces={workspaces}
        fetchWorkspaces={fetchWorkspaces}
        workspaceParam={urlParams.workspaceParam}
        selectOptions={filterOptions} 
        selectedFilterOption={selectedFilterOption} 
        setSelectedFilterOption={setSelectedFilterOption}
        helpModal={() => {cmd.helpModal(setModalUp)}}
        tokenModal={tokenModal}
        importModal={importModal}
        exportModal={exportModal}
      />
      <OverviewWindow
        node={selectedNodeObject} 
        modalUp={modalUp} 
        workspaceData={graphData.getWorkspaceData()}
        postMod={postMod}
      />
      <div className="hsplit">
        <SearchPanel 
          nodes={sortedNodes} 
          selectNode={selectNodeFromPanel} 
          selectedFilterOption={selectedFilterOption} 
          setFilteredNodes={setFilteredNodes}
        />
        <GraphComponent graphRef={graphRef} graphData={graphData} setNetwork={setNetwork} updateSelected={updateSelected} handleClick={handleClick}/>
      </div>
      <div id="modal-root"></div>
    </div>
  );
}
export default App;


